(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blindroam-cart-drawer"]) return;
  try {
    
(()=>{
if(window.brDrawerReady)return;window.brDrawerReady=true;
let busy=false,opener=null,oldOverflow='',cart=null;
const data=()=>document.getElementById('br-cart-data'),dialog=()=>document.getElementById('br-cart-drawer');
const cfg=()=>JSON.parse(data().querySelector('[data-brd-config]').textContent);
const root=()=>data().dataset.root;
const url=path=>{const u=new URL(root()+path,location.origin);const params=new URLSearchParams(location.search);for(const key of ['preview_theme_id','oseid'])if(params.has(key))u.searchParams.set(key,params.get(key));return u.href;};
const error=(message)=>{const el=dialog().querySelector('[data-error]');el.textContent=message;el.hidden=false;};
const request=async(path,body)=>{const r=await fetch(url(path),{method:body?'POST':'GET',credentials:'same-origin',signal:AbortSignal.timeout(12000),cache:'no-store',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});const result=await r.json();if(!r.ok)throw new Error(result.description||cfg().error);return result;};
const lock=(value)=>{busy=value;dialog().setAttribute('aria-busy',String(value));dialog().querySelectorAll('button:not([data-close]),select').forEach(el=>{el.disabled=value;});};
const prices=()=>{dialog()?.querySelectorAll('.brd-rec').forEach(card=>{const choice=card.querySelector('select[name=id]')?.selectedOptions[0];const price=choice?.dataset.price?choice.dataset:card.dataset;const active=card.dataset.offerActive==='true';card.querySelector('[data-rec-original]').hidden=!active||price.discounted!=='true';card.querySelector('[data-rec-original]').textContent=price.price;card.querySelector('[data-rec-price]').textContent=active?price.offer:price.price;card.querySelector('[data-rec-button-price]').textContent=active?card.dataset.saveLabel+' '+price.saving:price.price;if(active){card.querySelector('[data-pair-original]').textContent=price.pairOriginal;card.querySelector('[data-pair-price]').textContent=price.pair;}});};
const surface=()=>{const bg=document.querySelector('.background-container__image');if(bg){const src=bg.currentSrc||bg.src;if(src)dialog().style.setProperty('--brd-texture',`url("${src}")`);}prices();};
const open=()=>{const d=dialog();if(!d||d.open)return;opener=document.activeElement;oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';surface();d.showModal();d.querySelector('[data-close]').focus();};
const close=()=>{if(dialog()?.open)dialog().close();document.body.style.overflow=oldOverflow;opener?.focus?.();};
const paint=async()=>{const box=data(),d=dialog(),scroll=d.querySelector('.brd-scroll').scrollTop;const r=await fetch(url('?section_id='+encodeURIComponent(box.dataset.section)),{credentials:'same-origin',signal:AbortSignal.timeout(12000),cache:'no-store'});if(!r.ok)throw new Error(cfg().error);const html=new DOMParser().parseFromString(await r.text(),'text/html');const fresh=html.getElementById('br-cart-data');if(!fresh)throw new Error(cfg().error);d.innerHTML=fresh.querySelector('dialog').innerHTML;box.dataset.count=fresh.dataset.count;box.querySelector('[data-brd-config]').textContent=fresh.querySelector('[data-brd-config]').textContent;surface();d.querySelector('.brd-scroll').scrollTop=scroll;d.querySelector('[data-status]').textContent=cfg().updated;document.querySelectorAll('#CartCount,.cart-count,[data-cart-count]').forEach(el=>{el.textContent=box.dataset.count;});};
const sync=async()=>{cart=await request('cart.js');const c=cfg(),ids=new Set(c.preorder||[]);for(let i=0;i<100;i++){const line=cart.items.find(l=>ids.has(l.product_id)?l.properties?._preorder_shipping!==c.month||l.properties?.Shipping!==c.shipping:!!l.properties?._preorder_shipping);if(!line)return;const p={...line.properties};if(ids.has(line.product_id)){p._preorder_shipping=c.month;p.Shipping=c.shipping;}else{if(p._preorder_shipping)delete p.Shipping;delete p._preorder_shipping;}cart=await request('cart/change.js',{id:line.key,quantity:line.quantity,properties:p});}throw new Error(c.error);};
const run=async(action,focus)=>{if(busy)return;open();lock(true);dialog().querySelector('[data-error]').hidden=true;let failed=false;try{await action();await sync();await paint();if(focus)dialog().querySelector(focus)?.focus();}catch(e){failed=true;try{await paint();}catch(_){}error(e.name==='TimeoutError'?cfg().error:(e.message||cfg().error));}finally{lock(false);if(failed)dialog().querySelector('[name=checkout]')?.setAttribute('disabled','');}};
const add=async fd=>{fd.delete('checkout');const r=await fetch(url('cart/add.js'),{method:'POST',body:fd,signal:AbortSignal.timeout(12000),credentials:'same-origin',headers:{Accept:'application/json'}});const result=await r.json();if(!r.ok)throw new Error(result.description||cfg().error);};
document.addEventListener('click',event=>{if(!data())return;const target=event.target.closest('button,a');if(!target)return;if(target.matches('[data-close]')){close();return;}if(target.hasAttribute('data-qty')){const line=target.closest('[data-key]');run(()=>request('cart/change.js',{id:line.dataset.key,quantity:Number(target.dataset.qty)}),'[data-close]');return;}if(target.matches('#AddToCart')&&target.form){event.preventDefault();event.stopImmediatePropagation();if(!target.disabled&&target.form.reportValidity()){const fd=new FormData(target.form);run(()=>add(fd),'[data-close]');}return;}if(target.tagName==='A'&&!target.hasAttribute('data-full-cart')&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&new URL(target.href).pathname===data().dataset.cart){event.preventDefault();event.stopImmediatePropagation();run(async()=>{},'[data-close]');}},true);
document.addEventListener('submit',event=>{if(!data())return;const form=event.target;if(form.closest('#br-cart-drawer')&&event.submitter?.name==='checkout'){if(busy)event.preventDefault();return;}if(new URL(form.action).pathname.endsWith('/cart/add')){event.preventDefault();event.stopImmediatePropagation();if(!busy&&form.reportValidity()){const fd=new FormData(form);run(()=>add(fd),'[data-close]');}}},true);
document.addEventListener('change',event=>{if(event.target.matches('#br-cart-drawer [data-rec-form] select')){prices();return;}if(!event.target.matches('#br-cart-drawer [data-size]'))return;const select=event.target,line=select.closest('[data-key]'),id=Number(select.value),key=line.dataset.key;run(async()=>{cart=await request('cart.js');const original=cart.items.find(i=>i.key===key);if(!original)throw new Error(cfg().error);const replacement={id,quantity:original.quantity,properties:original.properties||{}};if(original.selling_plan_allocation)replacement.selling_plan=original.selling_plan_allocation.selling_plan.id;await request('cart/add.js',{items:[replacement]});const latest=await request('cart.js');const old=latest.items.find(i=>i.key===key)||latest.items.find(i=>i.variant_id===original.variant_id&&JSON.stringify(i.properties)===JSON.stringify(original.properties));if(!old)throw new Error(cfg().error);await request('cart/change.js',{id:old.key,quantity:0});},'[data-close]');});
document.addEventListener('cancel',event=>{if(event.target.id==='br-cart-drawer'){event.preventDefault();close();}},true);
document.addEventListener('click',event=>{if(event.target===dialog()){const r=dialog().getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right)close();}});
window.addEventListener('pageshow',event=>{if(event.persisted){busy=false;if(dialog()?.open)close();}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blindroam-contact"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('br-contact'))customElements.define('br-contact',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const opts={signal:this.abort.signal};
  const button=this.querySelector('button'),email=this.querySelector('.br-contact__email');
  email.inert=true;this.classList.add('is-ready');let start=null,moved=false;
  const reveal=()=>{this.classList.remove('is-dragging');button.style.transform='';this.classList.add('is-open');button.disabled=true;email.inert=false;email.querySelector('a').focus({preventScroll:true})};
  button.addEventListener('click',()=>{if(!moved)reveal()},opts);
  button.addEventListener('pointerdown',e=>{start=e.clientX;moved=false;button.setPointerCapture(e.pointerId)},opts);
  button.addEventListener('pointermove',e=>{if(start===null)return;const delta=Math.max(0,start-e.clientX);if(delta>6){moved=true;this.classList.add('is-dragging');button.style.transform=`translateX(${-delta*.7}px) rotateY(${-Math.min(delta*.3,60)}deg)`}},opts);
  const end=e=>{if(start===null)return;const distance=start-e.clientX;start=null;this.classList.remove('is-dragging');button.style.transform='';if(distance>45)reveal()};
  button.addEventListener('pointerup',end,opts);
  button.addEventListener('pointercancel',()=>{start=null;moved=false;this.classList.remove('is-dragging');button.style.transform=''},opts);
 }
 disconnectedCallback(){this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blindroam-customer-photos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('br-customer-photos'))customElements.define('br-customer-photos',class extends HTMLElement{
 connectedCallback(){
  this.controller=new AbortController();const signal=this.controller.signal;
  const track=this.querySelector('.br-proof__track'),group=this.querySelector('.br-proof__group');
  if(group.querySelectorAll('img').length<2)return;
  const original=[...group.children];
  while(group.scrollWidth<this.querySelector('.br-proof__viewport').clientWidth*1.2){original.forEach(item=>{const copy=item.cloneNode(true);copy.removeAttribute('data-shopify-editor-block');copy.setAttribute('aria-hidden','true');group.append(copy)})}
  const clone=group.cloneNode(true);clone.dataset.proofClone='';clone.setAttribute('aria-hidden','true');clone.setAttribute('inert','');clone.querySelectorAll('[data-shopify-editor-block]').forEach(el=>el.removeAttribute('data-shopify-editor-block'));track.append(clone);this.classList.add('is-running');
  const button=this.querySelector('button');button?.addEventListener('click',()=>{const paused=this.classList.toggle('is-paused');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?button.dataset.play:button.dataset.pause},{signal});
  this.querySelector('.br-proof__viewport').addEventListener('touchstart',()=>{if(button)this.classList.add('is-paused');else this.classList.toggle('is-paused');if(button){button.setAttribute('aria-pressed','true');button.textContent=button.dataset.play}},{signal,passive:true});
 }
 disconnectedCallback(){this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blindroam-lookbook"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('br-lookbook')) {
  customElements.define('br-lookbook', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.br-lookbook__track');
      this.slides = [...this.track.children];
      this.total = this.slides.length;
      if (!this.total) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.loop = this.total > 1;
      if (this.loop) {
        const clone = slide => {
          const copy = slide.cloneNode(true);
          copy.removeAttribute('data-shopify-editor-block');
          copy.setAttribute('aria-hidden', 'true');
          copy.setAttribute('inert', '');
          copy.dataset.clone = 'true';
          return copy;
        };
        this.track.prepend(clone(this.slides[this.total - 1]));
        this.track.append(clone(this.slides[0]));
      }
      this.items = [...this.track.children];
      this.querySelectorAll('button[data-direction]').forEach(button => {
        button.disabled = !this.loop;
        button.addEventListener('click', () => this.move(Number(button.dataset.direction)), options);
      });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.go(event.key === 'Home' ? 0 : this.total - 1);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.update(); this.frame = null; });
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.settle(), 160);
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.indexOf(event.target.closest('.br-lookbook__slide'));
        if (index >= 0) this.go(index);
      }, options);
      let drag = null;
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, left: this.track.scrollLeft };
        this.track.style.scrollSnapType = 'none';
        this.track.setPointerCapture(event.pointerId);
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (drag) this.track.scrollLeft = drag.left - (event.clientX - drag.x);
      }, options);
      const release = () => {
        if (!drag) return;
        drag = null;
        this.track.style.scrollSnapType = '';
        this.update();
        this.center(this.items[this.nearest], true);
      };
      this.track.addEventListener('pointerup', release, options);
      this.track.addEventListener('pointercancel', release, options);
      this.resize = new ResizeObserver(() => this.go(this.index, false));
      this.resize.observe(this.track);
      requestAnimationFrame(() => { this.go(0, false); this.classList.add('is-ready'); });
    }
    center(item, smooth) {
      const left = item.offsetLeft - this.track.offsetLeft - (this.track.clientWidth - item.offsetWidth) / 2;
      this.track.scrollTo({ left, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
    }
    go(index, smooth = true) {
      this.index = index;
      this.center(this.slides[index], smooth);
      this.update();
    }
    move(direction) {
      this.update();
      const target = Math.max(0, Math.min(this.items.length - 1, this.nearest + direction));
      this.center(this.items[target], true);
    }
    update() {
      const midpoint = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      let distance = Infinity;
      this.items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const delta = Math.abs(rect.left + rect.width / 2 - midpoint);
        if (delta < distance) { distance = delta; this.nearest = index; }
      });
      this.items.forEach((item, index) => item.classList.toggle('is-active', index === this.nearest));
      this.index = (this.nearest - (this.loop ? 1 : 0) + this.total) % this.total;
      const counter = this.querySelector('[data-current]');
      if (counter) counter.textContent = String(this.index + 1).padStart(2, '0');
    }
    settle() {
      this.update();
      if (this.loop && (this.nearest === 0 || this.nearest === this.items.length - 1)) this.go(this.index, false);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      clearTimeout(this.timer);
      cancelAnimationFrame(this.frame);
      this.querySelectorAll('[data-clone]').forEach(item => item.remove());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blindroam-messages"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('br-message-wall')) customElements.define('br-message-wall', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.copy = JSON.parse(this.querySelector('[data-messages-copy]').textContent);
    this.form = this.querySelector('form');
    this.input = this.querySelector('textarea');
    this.submit = this.querySelector('[type="submit"]');
    this.submitLabel = this.querySelector('[data-message-submit-label]');
    this.status = this.querySelector('[role="status"]');
    this.notes = this.querySelector('ul');
    this.more = this.querySelector('.br-messages__more');
    this.seen = new Set();
    this.cursor = '';
    this.sent = false;
    this.pendingSubmit = false;
    this.notes.replaceChildren();
    this.more.hidden = true;
    this.token = '';
    this.ready = false;
    this.busy = false;
    this.config = null;
    this.input.addEventListener('input', () => {
      this.querySelector('.br-messages__count').textContent = `${this.input.value.length} / 400`;
      this.updateButton();
    }, {signal});
    this.input.addEventListener('focus', () => this.prepareVerification(), {signal});
    this.form.addEventListener('submit', event => {event.preventDefault(); this.post();}, {signal});
    this.more.addEventListener('click', () => this.config ? this.loadNotes() : this.initialize(), {signal});
    if (!this.dataset.api) return;
    try {
      this.base = new URL(this.dataset.api);
      const localTest = ['localhost','127.0.0.1'].includes(location.hostname) && this.base.origin === location.origin;
      if (this.base.protocol !== 'https:' && !localTest) return;
      this.base.search = ''; this.base.hash = '';
      if (!this.base.pathname.endsWith('/')) this.base.pathname += '/';
    } catch {return;}
    this.initialize();
  }
  async request(path, options = {}) {
    const signal = AbortSignal.any([this.controller.signal, AbortSignal.timeout(15000)]);
    const response = await fetch(new URL(path, this.base), {...options, signal, credentials:'omit', cache:'no-store'});
    const data = await response.json();
    if (!response.ok) {const error = new Error(data.error || 'request'); error.status = response.status; throw error;}
    return data;
  }
  async initialize() {
    const results = await Promise.allSettled([this.request('v1/config'), this.loadNotes()]);
    if (!this.isConnected || this.controller.signal.aborted) return;
    if (results[0].status === 'fulfilled' && results[0].value.siteKey) {
      this.config = results[0].value;
      this.ready = true;
      this.updateButton();
      if (this.input === document.activeElement || this.input.value) this.prepareVerification();
    } else {
      this.status.textContent = this.copy.loadError;
      this.more.textContent = this.copy.retry;
      this.more.hidden = false;
    }
  }
  updateButton() {this.submit.disabled = !this.ready || this.busy || !this.input.value.trim();}
  async prepareVerification() {
    if (!this.config || this.widget !== undefined || this.verifying) return;
    this.verifying = true;
    try {
      if (!window.brMessagesTurnstile) {
        window.brMessagesTurnstile = new Promise((resolve,reject) => {
          if (window.turnstile?.render) return resolve();
          const script = document.createElement('script');
          script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          script.async = true;
          script.onload = resolve;
          script.onerror = () => {script.remove();window.brMessagesTurnstile=null;reject(new Error('verification'));};
          document.head.append(script);
        });
      }
      await window.brMessagesTurnstile;
      if (!this.isConnected || this.controller.signal.aborted) return;
      this.widget = window.turnstile.render(this.querySelector('.br-messages__verification'), {
        sitekey:this.config.siteKey, action:'leave-message', appearance:'interaction-only', size:'flexible',
        callback:token=>{this.token=token; if(this.status.textContent===this.copy.verify) this.status.textContent='';if(this.pendingSubmit){this.pendingSubmit=false;this.post();}},
        'expired-callback':()=>{this.token='';},
        'error-callback':()=>{this.token='';this.status.textContent=this.copy.verificationError;return true;}
      });
    } catch {if(!this.controller.signal.aborted)this.status.textContent=this.copy.verificationError;}
    finally {this.verifying=false;}
  }
  addNote(note, prepend = false) {
    if (!note || typeof note.id !== 'string' || typeof note.body !== 'string' || this.seen.has(note.id)) return;
    this.seen.add(note.id);
    const item = document.createElement('li'); item.className='br-messages__note';
    const body = document.createElement('p'); body.textContent=note.body;
    item.append(body); prepend ? this.notes.prepend(item) : this.notes.append(item);
  }
  async loadNotes() {
    if (!this.base || this.loadingNotes) return;
    this.loadingNotes=true;this.more.disabled=true;
    try {
      const data = await this.request(`v1/messages${this.cursor ? '?cursor='+encodeURIComponent(this.cursor) : ''}`);
      if (!this.isConnected || this.controller.signal.aborted) return;
      data.messages.forEach(note=>this.addNote(note));
      this.cursor=data.cursor || '';
      this.more.hidden=!this.cursor;this.more.textContent=this.copy.loadMore;
      if (!this.busy && !this.sent) this.status.textContent='';
    } catch {
      if(this.controller.signal.aborted)return;
      this.status.textContent=this.copy.loadError;this.more.textContent=this.copy.retry;this.more.hidden=false;
    } finally {this.loadingNotes=false;this.more.disabled=false;}
  }
  async post() {
    if (this.busy || !this.ready) return;
    const body=this.input.value.trim();
    if (!body) {this.status.textContent=this.copy.missing;this.input.focus();return;}
    if(body.length>400){this.status.textContent=this.copy.limit;return;}
    if(!navigator.onLine){this.status.textContent=this.copy.offline;return;}
    if(!this.token){this.pendingSubmit=true;this.status.textContent=this.copy.verify;await this.prepareVerification();return;}
    this.busy=true;this.updateButton();this.submitLabel.textContent=this.copy.posting;
    try {
      if(!this.requestId || this.requestBody!==body){this.requestId=crypto.randomUUID();this.requestBody=body;}
      const data=await this.request('v1/messages',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:this.requestId,body,token:this.token})});
      this.sent=true;this.input.value='';this.input.dispatchEvent(new Event('input'));
      this.status.textContent=data.status==='published'?this.copy.published:this.copy.pending;
      if(data.status==='published')this.addNote({id:data.id,body},true);
      this.requestId=null;this.requestBody=null;
    } catch(error) {
      if(this.controller.signal.aborted)return;
      this.status.textContent=['no_links','plain_text_only'].includes(error.message)?this.copy.noLinks:error.status===429?this.copy.slowDown:error.status===403?this.copy.verificationError:this.copy.error;
    } finally {
      this.token='';if(this.widget!==undefined)window.turnstile?.reset(this.widget);
      this.busy=false;this.submitLabel.textContent=this.copy.submit;this.updateButton();
    }
  }
  disconnectedCallback() {
    this.controller?.abort();
    if(this.widget!==undefined)window.turnstile?.remove(this.widget);
    this.widget=undefined;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if(!customElements.get('br-scramble'))customElements.define('br-scramble',class extends HTMLElement{
 connectedCallback(){
  this.original=this.textContent;this.motion=matchMedia('(prefers-reduced-motion: reduce)');const menu=this.closest('details');
  this.burst=()=>{if(this.motion.matches||document.hidden||!menu?.open)return;clearInterval(this.frames);let step=0;const chars='abcdefhkmnprstuvwxyz/+=?';this.frames=setInterval(()=>{step++;if(step>6){clearInterval(this.frames);this.textContent=this.original;return}this.textContent=[...this.original].map((c,i)=>c!==' '&&(i===step%this.original.length||i===(step+3)%this.original.length)?chars[Math.floor(Math.random()*chars.length)]:c).join('')},70)};
  this.timer=setInterval(this.burst,5200);this.listener=()=>{if(menu.open)this.burst();else{clearInterval(this.frames);this.textContent=this.original}};menu?.addEventListener('toggle',this.listener);this.menu=menu;
 }
 disconnectedCallback(){clearInterval(this.timer);clearInterval(this.frames);this.menu?.removeEventListener('toggle',this.listener)}
});

if(!customElements.get('br-preorder-countdown'))customElements.define('br-preorder-countdown',class extends HTMLElement{
  connectedCallback(){
    this.label=this.querySelector('[data-window-label]');this.clock=this.querySelector('[data-window-time]');
    this.opens=Date.parse(this.dataset.opens);this.closes=Date.parse(this.dataset.closes);
    if(!Number.isFinite(this.opens)||!Number.isFinite(this.closes)||this.closes<=this.opens){this.hidden=true;this.style.display='none';return;}
    this.update=()=>{
      if(document.hidden)return;
      const now=Date.now(),state=this.stateAt(now),phase=state.phase;
      if(this.dataset.phase!==phase){this.dataset.phase=phase;this.label.textContent=this.dataset[phase];}
      if(this.clock.dataset.value!==state.text){this.clock.dataset.value=state.text;const parts=state.text.split(':');this.clock.querySelectorAll('[data-window-value]').forEach((node,index)=>{node.textContent=parts[index]||'00';});}
      if(phase==='closed'){clearInterval(this.timer);}
    };
    this.update();if(Date.now()<this.closes)this.timer=setInterval(this.update,1000);
    document.addEventListener('visibilitychange',this.update);
  }
  stateAt(now){
    const phase=now>=this.closes?'closed':this.closes-now<=86400000?'final':this.closes-now<=172800000?'last':'open';
    if(phase==='closed')return{phase,text:''};
    const seconds=Math.max(0,Math.ceil((this.closes-now)/1000));
    const d=Math.floor(seconds/86400),h=Math.floor(seconds%86400/3600),m=Math.floor(seconds%3600/60),s=seconds%60,p=n=>String(n).padStart(2,'0');
    return{phase,text:`${p(d)}:${p(h)}:${p(m)}:${p(s)}`};
  }
  disconnectedCallback(){clearInterval(this.timer);document.removeEventListener('visibilitychange',this.update);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if(!customElements.get('br-returns-modal'))customElements.define('br-returns-modal',class extends HTMLElement{
  connectedCallback(){
    this.controller=new AbortController();const options={signal:this.controller.signal};
    this.dialog=this.querySelector('dialog');this.trigger=this.closest('[data-section-type="product-template"]').querySelector('[data-returns-open]');
    this.trigger.addEventListener('click',event=>{event.preventDefault();this.dialog.showModal();document.documentElement.classList.add('br-returns-lock');},options);
    this.querySelector('[data-returns-close]').addEventListener('click',()=>this.dialog.close(),options);
    let outside=false;this.dialog.addEventListener('pointerdown',event=>{const r=this.dialog.getBoundingClientRect();outside=event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom;},options);
    this.dialog.addEventListener('click',event=>{if(outside&&event.target===this.dialog)this.dialog.close();outside=false;},options);
    this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('br-returns-lock');this.trigger.focus({preventScroll:true});},options);
  }
  disconnectedCallback(){this.controller?.abort();if(this.dialog?.open)document.documentElement.classList.remove('br-returns-lock');}
});

  } catch(e) { console.error(e); }
})();
})();
